import { Button } from "@components/ui/Button"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Header Button",
  icon: "forms",
  tags: ["#header-button"],
  lazyLoad: false,
  blockStyles: [
    {
      name: "ghost",
      label: "Ghost",
      isDefault: true,
    },
    {
      name: "primary",
      label: "Primary",
    },
  ],
}

export default defineBlock("parts/header-button", (props) => {
  const link = props.link

  const button = (
    <Button
      href={link?.url}
      target={link?.target}
      shape="branded"
      variant={props.blockStyle === "primary" ? "primary" : "ghost"}
      data-mixpanel-area="Header Buttons"
    >
      <EditableText
        store="label"
        defaultValue={props.link?.title}
        placeholder="Button"
        appendOnEnter="core/paragraph"
        removeOnDelete
        plainText
      />
    </Button>
  )

  return button
})
